import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'fund-geographical-focus',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'fund-geographical-focus',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'fund-geographical-focus',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'fund-geographical-focus',
  action: ActionType.UPDATE,
};

export const FundGeographicalFocus = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
